import { isValidImageSrc } from "@/app/utils/isValidImageSrc";

const OImages = ({
	imgsSrc,
	strokeColor,
	pathFill,
	pathOpacity,
	svgCustomClass,
	startPostion,
}: {
	imgsSrc?: string[];
	strokeColor?: string;
	pathFill?: string;
	pathOpacity?: string;
	svgCustomClass?: string;
	startPostion?: string;
}) => {
	return (
		<svg
			fill="none"
			viewBox="0 0 875 897"
			xmlns="http://www.w3.org/2000/svg"
			className={svgCustomClass}
		>
			<defs>
				<clipPath id="circle-clip">
					<path
						fill="black"
						d="M436.264 897C370.214 897 310.386 885.51 256.78 862.531C203.175 839.551 157.227 808.114 119.017 768.219C80.7275 728.324 51.372 681.008 30.7913 626.193C10.2106 571.377 0 512.172 0 448.5C0 384.827 10.2904 325.623 30.7913 270.807C51.372 215.992 80.7275 168.676 119.017 128.781C157.307 88.8861 203.175 57.4488 256.78 34.4693C310.386 11.4898 370.214 0 436.264 0C502.313 0 563.577 11.4898 617.581 34.4693C671.586 57.4488 717.693 88.8861 755.983 128.781C794.272 168.676 823.628 215.992 844.209 270.807C864.789 325.623 875 384.827 875 448.5C875 512.172 864.71 571.377 844.209 626.193C823.628 681.008 794.272 728.324 755.983 768.219C717.693 808.114 671.586 839.551 617.581 862.531C563.577 885.51 503.191 897 436.264 897ZM436.264 866.839C492.661 866.839 541.401 856.148 582.482 834.684C623.564 813.3 657.227 783.937 683.392 746.835C709.556 709.653 728.941 665.609 741.385 614.703C753.829 563.797 760.131 508.422 760.131 448.58C760.131 388.737 753.909 333.443 741.385 282.457C728.861 231.551 709.556 187.267 683.392 149.686C657.227 112.105 623.564 82.8221 582.482 61.7576C541.401 40.7728 492.661 30.2404 436.264 30.2404C379.866 30.2404 331.525 40.7728 291.241 61.7576C250.957 82.8221 217.693 112.105 191.528 149.686C165.364 187.267 145.98 231.471 133.535 282.457C121.011 333.363 114.789 388.737 114.789 448.58C114.789 508.422 121.251 563.797 134.094 614.703C146.937 665.609 166.72 709.653 193.283 746.835C219.847 784.017 253.271 813.3 293.634 834.684C333.918 856.068 381.461 866.839 436.264 866.839Z"
					/>
				</clipPath>
			</defs>
			{imgsSrc?.filter(isValidImageSrc).map((item: string, index: number) => (
				<image
					key={index}
					href={item}
					y={index > 0 ? "100%" : startPostion}
					width="875"
					height="897"
					style={{ clipPath: "url(#circle-clip)" }}
					preserveAspectRatio="xMidYMid slice"
				/>
			))}
			<path
				id="empty-path"
				opacity={pathOpacity || "0.1"}
				fill={pathFill || "none"}
				stroke={strokeColor || "#0E223E"}
				d="M436.264 897C370.214 897 310.386 885.51 256.78 862.531C203.175 839.551 157.227 808.114 119.017 768.219C80.7275 728.324 51.372 681.008 30.7913 626.193C10.2106 571.377 0 512.172 0 448.5C0 384.827 10.2904 325.623 30.7913 270.807C51.372 215.992 80.7275 168.676 119.017 128.781C157.307 88.8861 203.175 57.4488 256.78 34.4693C310.386 11.4898 370.214 0 436.264 0C502.313 0 563.577 11.4898 617.581 34.4693C671.586 57.4488 717.693 88.8861 755.983 128.781C794.272 168.676 823.628 215.992 844.209 270.807C864.789 325.623 875 384.827 875 448.5C875 512.172 864.71 571.377 844.209 626.193C823.628 681.008 794.272 728.324 755.983 768.219C717.693 808.114 671.586 839.551 617.581 862.531C563.577 885.51 503.191 897 436.264 897ZM436.264 866.839C492.661 866.839 541.401 856.148 582.482 834.684C623.564 813.3 657.227 783.937 683.392 746.835C709.556 709.653 728.941 665.609 741.385 614.703C753.829 563.797 760.131 508.422 760.131 448.58C760.131 388.737 753.909 333.443 741.385 282.457C728.861 231.551 709.556 187.267 683.392 149.686C657.227 112.105 623.564 82.8221 582.482 61.7576C541.401 40.7728 492.661 30.2404 436.264 30.2404C379.866 30.2404 331.525 40.7728 291.241 61.7576C250.957 82.8221 217.693 112.105 191.528 149.686C165.364 187.267 145.98 231.471 133.535 282.457C121.011 333.363 114.789 388.737 114.789 448.58C114.789 508.422 121.251 563.797 134.094 614.703C146.937 665.609 166.72 709.653 193.283 746.835C219.847 784.017 253.271 813.3 293.634 834.684C333.918 856.068 381.461 866.839 436.264 866.839Z"
			/>
		</svg>
	);
};

export default OImages;
